import { PogNonCircular, TemplatePogThumbnail } from "@CommonTypes/merchflow/pog/pog";

export const RouteGetMerchflows_merchflowId_Templates = "/merchflows/:merchflowId/templates";

export const RouteGetMerchflows_merchflowId_TemplatesList =
  "/merchflows/:merchflowId/templates/list";

export type ResponseGetMerchflows_merchflowId_Templates = BasePogTemplate[];

export type ResponseGetMerchflows_merchflowId_TemplatesList = (Omit<BasePogTemplate, "base_pog"> & {
  base_pog: Pick<BasePogTemplate["base_pog"], "base_pog_id" | "base_pog_status"> & {
    base_pog_data: {
      metrics: PogNonCircular["metrics"] | null;
    };
  };
})[];

export interface BasePogTemplate {
  template_id: string;
  total_base_pog: number;
  total_favourite_base_pog: number;
  base_pog: {
    base_pog_id: number;
    base_pog_data: PogNonCircular | null;
    base_pog_status: "NOT_STARTED" | "IN_PROGRESS" | "DONE" | "ERROR";
    thumbnail: TemplatePogThumbnail;
  };
}
